import React from 'react';

function RightArrow() {
    return (
        <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.17321 7.8419C0.0577367 7.7365 0 7.6117 0 7.46751C0 7.3236 0.0577367 7.19895 0.17321 7.09354L3.55658 4.00527L0.161663 0.906456C0.0538876 0.808081 0 0.685112 0 0.537549C0 0.389987 0.0577367 0.263505 0.17321 0.158103C0.288684 0.0527009 0.425404 0 0.583372 0C0.741032 0 0.877598 0.0527009 0.993072 0.158103L4.87298 3.71014C4.91917 3.75231 4.95196 3.79798 4.97136 3.84717C4.99045 3.89635 5 3.94906 5 4.00527C5 4.06148 4.99045 4.11419 4.97136 4.16337C4.95196 4.21256 4.91917 4.25823 4.87298 4.3004L0.981524 7.85244C0.873749 7.95081 0.741032 8 0.583372 8C0.425404 8 0.288684 7.9473 0.17321 7.8419Z" fill="#868691"/>
        </svg>

    );
}

export default RightArrow;